// extracted by mini-css-extract-plugin
module.exports = {"paginationRow":"Paginate_paginationRow__28TNE","pageSize":"Paginate_pageSize__2JWGC"};